import SwipingInbox from "./swiping-inbox-mapping";

export default SwipingInbox;
